export const projectsData = [
  {
    title: "Jubilee Bridge",
    image: "/Jubilee Bridge/Jubilee Bridge Button Image.png",
    link: "/home_project/jubilee_bridge",
    client: "Auckland Council & CLL",
    location: "New Zealand",
    services: `Drone capture of existing environment & Develop 3D models of the existing 
bridge and the proposed bridge&Develop lift plan&Develop methodology drawings for 
the tender submission`,
    introduction:
      "Transporting the assembled Jubilee Bridge structure—measuring approximately 10m in height, 61m in length, and 5m in width—over a 1.5 km route through a busy urban area posed significant logistical challenges, including navigating traffic lights, roadlights, and tight turning points. To ensure a safe and efficient process, our team conducted comprehensive site analysis using drone scans and 3D modeling. As certain elements like road and traffic lights could not be accurately captured, they were manually modeled based on surveyed specifications and manufacturer data. These were integrated into the 3D model for detailed turning simulations, which identified three high-risk turning points and allowed for precise clearance assessments. The bridge was lifted onto the jinker by crane and transported under real-time drone monitoring, with team members positioned strategically to manage critical clearances. This meticulous pre-planning, supported by scenario testing and early design verification, ensured the structure was moved without collisions or delays. Our innovative, constructability-focused approach—balancing affordability and technical constraints—formed the basis of a successful $7.5 million tender submission, which included ten detailed methodology drawings covering the full process from demolition to offsite construction and installation.",
    showcase: "https://youtu.be/CvIWO1hy254",

    outcome: {
      image: [
        "/Jubilee Bridge/WorkExample0.png",
        "/Jubilee Bridge/WorkExample1.png",
        "/Jubilee Bridge/WorkExample2.png",
        "/Jubilee Bridge/WorkExample3.png",
      ],
    },
  },
  {
    title: "P2P Electrification",
    introduction:
      "The P2P project, which involved electrifying several kilometers of rail between Papakura and Pukekohe, faced significant program constraints, particularly as foundation works had to be carried out under single-line-running conditions. To address these challenges, CLL and key stakeholders proposed a new design—used for the first time on the Auckland network—which required a novel construction methodology tailored to the project’s unique demands. This methodology was transformed into an animated sequence that clearly showcased CLL’s capabilities and illustrated how the works could be executed effectively within the project constraints. The animation served as a valuable communication tool, helping ensure alignment and understanding among all stakeholders.",
    showcase: "https://www.youtu.be/WhsOEf8YJpg",

    image: "/P2P Electrification/Button PNG.png",
    link: "/home_project/p2p_electrification",
    client: "CLL",
    location: "Auckland, New Zealand",
    services:
      "Facilitate methodology workshops&3D models of key equipment&Game rigging of equipment models&Animation of the proposed methodology&Corridor model of work area",

    outcome: {
      image: [
        "/P2P Electrification/Outcome 1.png",
        "/P2P Electrification/Outcome 2.png",
        "/P2P Electrification/Outcome 3.png",
      ],
    },
  },
  {
    title: "Moss Vale Station and Stabling Yard Upgrade",
    image: "/Moss Vale/Button PNG.png",
    link: "/home_project/moss_vale",
    showcase: "https://youtu.be/JJgmimerqCg",
    introduction:
      "For the Moss Vale Road Upgrade - Nowra Bridge project by Transport for NSW, a detailed video rendering was developed to visually communicate the final design and operational aspects of the upgraded infrastructure. The workflow incorporated Rhino and Revit for custom environmental modeling, ensuring the surrounding context closely matched the actual site conditions. Twinmotion was used for real-time rendering, with animated elements such as moving vehicles, trains, and pedestrians added to enhance realism and clearly demonstrate traffic flow and pedestrian connectivity. The final video serves as an effective tool for public consultation, stakeholder communication, and early-stage project promotion.",
    client: "Degnan & Transport for NSW",
    location: "New South Wales, Australia",
    services:
      "3D Modeling & Environmental Context Building & Visual Rendering & Animation & Infrastructure Visualization & Promotional Video Production",
    outcome: {
      image: [
        "/Moss Vale/Outcome 1.png",
        "/Moss Vale/Outcome 2.png",
        "/Moss Vale/Outcome 3.png",
      ],
    },
  },
  {
    title: "SH Loop Road Tender",

    introduction: `The Contractor entrusted us with delivering the methodology submission 
      of the largest tender they have engaged in. This required resolving 
      complex traffic management requirements in which two-way traffic on the 
      State Highway must be maintained throughout project. It also involved 
      estimating the quantity of large scale earthworks and preload required 
      for the embankment and the significant ground improvement needed 
      prior to bridge construction.`,
    showcase: "/Sh Loop Road Tender/Problem Photo.png",

    image: "/Sh Loop Road Tender/Button Png.png",
    link: "/home_project/sh_loop_road_tender",
    client: "Oxcon CLL & NZ Transport Agency",
    location: "Whangarei New Zealand",
    services:
      "Drone flyover of site route&Corridor modelling of entire project&Generate schedule quantities&Facilitate methodology workshops&Build geotechnical subsurface model&3D modelling of bridge temporary works&Publish methodology",

    outcome: {
      image: [
        "/Sh Loop Road Tender/Outcome 1.png",
        "/Sh Loop Road Tender/Outcome 2.png",
        "/Sh Loop Road Tender/Outcome 3.png",
      ],
    },
  },
  {
    title: "50 Albert Street",

    introduction:
      "This engagement focused on constructing the foundations for a multi-storey office building in the busy Auckland CBD, where the main challenges included demolishing the existing building and retaining walls adjacent to the newly constructed City Rail Link (CRL) tunnel and busy Albert Street. The complexity was heightened by the need to maintain tight tolerances near existing structures and construct intricate temporary retaining walls to support excavation. To overcome these challenges, a collaborative approach was taken with key subcontractors, designers, and the principal. Simple 3D models of the construction methodology were used in workshops to identify issues and develop practical solutions. These sessions resulted in draft methodologies, a detailed construction programme, and a comprehensive construction budget. The final methodologies were published to guide site teams through execution. Key deliverables included detailed construction methodology drawings and a resourced construction programme outlining the timeline, required resources, and processes to ensure efficient and effective project delivery.",

    showcase: "/st.albert/Problem Photo.png",

    image: "/st.albert/Button PNG.png",
    link: "/home_project/st_albert_street",
    client: "CLL",
    location: "Auckland New Zealand",
    services:
      "Drone flyover of site route&Corridor modelling of entire project&Generate schedule quantities&Facilitate methodology workshops&Build geotechnical subsurface model&3D modelling of bridge temporary works&Publish methodology",

    outcome: {
      image: [
        "/st.albert/Outcome 1.png",
        "/st.albert/Outcome 2.png",
        "/st.albert/Outcome 3.png",
      ],
    },
  },
  {
    title: "Glen Innes to Tamaki Drive Shared Path - Section 2",
    image: "/GI2TD-S2/Button PNG.png",
    link: "/home_project/gi2td_s2",

    showcase: "/GI2TD-S2/Problem Photo.png",
    introduction:
      "Section 2 of the Glen Innes to Tāmaki Drive Shared Path, known as Te Ara Ki Uta Ki Tai (the path of land and sea), is a 2.65-kilometre link connecting St Johns Road to the Ōrākei Basin. Completed in May 2022, it forms a key segment of Auckland's 7-kilometre shared path corridor, designed to promote walking and cycling between the eastern suburbs and the city centre.",
    client: "NZ Transport Agency & Oxcon CLL",
    location: "Auckland, New Zealand",
    services: "",
    outcome: {
      image: [
        "/GI2TD-S2/Outcome 1.png",
        "/GI2TD-S2/Outcome 2.png",
        "/GI2TD-S2/Outcome 3.png",
      ],
    },
  },
  {
    title: "Drury Rail Stations",
    image: "/Drury Station/Button PNG.png",
    link: "/home_project/drury_station",

    showcase: "/Drury Station/Problem Photo.png",
    introduction:
      "The Drury Rail Stations project was a major infrastructure initiative designed to future-proof South Auckland's public transport network in response to the region's rapid growth. With the area projected to welcome over 130,000 new residents in the coming decades, the project delivered three new railway stations—Drury Central, Ngākōroa (Drury West), and Paerātā—each strategically positioned to improve connectivity between new communities and the wider Auckland rail network.",
    client: "KiwiRail & John Holland",
    location: "Auckland, New Zealand",
    services: "",
    outcome: {
      image: [
        "/Drury Station/Outcome 1.png",
        "/Drury Station/Outcome 2.png",
        "/Drury Station/Outcome 3.png",
      ],
    },
  },
  {
    title: "Central Interceptor",
    image: "/Central Interceptor/Button PNG.png",
    link: "/home_project/central_interceptor",

    showcase: "/Central Interceptor/Problem Photo.png",
    introduction: `Our client took on the challenge of drilling the biggest shafts 
      as part of the CI project. Keith Hay Park at 84m deep and 
      Walmsley at 67m deep both presented significant difficulties. 
      At 4.1m diameter and using an untested piling methodology, 
      we were tasked with assisting in answering some the key 
      questions around the methodology. 
      We developed numerical models to predict the forces to 
      confirm the suitability of the piling rig and a separate model 
      for estimating the drilling durations to guide the pricing 
      and programme development. We worked with the project 
      team  to refine the methodology and publish the proposed 
      approach for presentation to all the stakeholders.`,
    client: "CLL & Ghella & ABERGELDIE & Watercare",
    location: "Auckland, New Zealand",
    services: `Develop a force model to confirm 
      suitability of piling rig capacities&Develop a time-series model to 
      predict drilling durations&Facilitate workshops to identify risks 
      and refine methodology&Publish and present methodology to 
      the client`,
    outcome: {
      image: [
        "/Central Interceptor/Outcome 1.png",
        "/Central Interceptor/Outcome 2.png",
        "/Central Interceptor/Outcome 3.png",
      ],
    },
  },
  {
    title: "Te Kaha Stadium",
    image: "/Te Kaha Stadium/Button PNG.png",
    link: "/home_project/te_kaha_stadium",
    showcase: "https://www.youtu.be/qox8URf2HQI",
    introduction: `Te Kaha, officially known as One New Zealand Stadium, is a transformative multi-use arena under construction in central Christchurch. Conceived as the final anchor project of the Christchurch Central Recovery Plan following the 2011 earthquake, the $683 million stadium is set to reinvigorate the city's cultural and sporting landscape. Located between Madras, Barbadoes, Hereford, and Tuam streets, the venue will feature a fully enclosed roof incorporating Ethylene Tetrafluoroethylene (ETFE) panels to allow natural light while protecting spectators from the elements. With a seating capacity of 30,000 for sports events and up to 36,000 for concerts, Te Kaha is designed to host a range of events, from All Blacks tests to international music performances. Construction commenced in June 2022, led by the Kōtui consortium, which includes BESIX Watpac, Southbase Construction, Fulton Hogan, and design experts Populous and Warren and Mahoney. The project remains on schedule for completion in April 2026.`,
    client: "CLL & Besix Watpac",
    location: "Birkenhead, Christchurch",
    services:
      "Revit Family Development & Parameter Setup & Dynamo Scripting & QA Data Integration",
    outcome: {
      image: [],
    },
  },
  {
    title: "Sudima Hotel",
    image: "/Sudima Hotel/Button PNG.png",
    link: "/home_project/sudima_hotel",

    showcase: "https://youtu.be/-Nlss_mSADI",
    introduction:
      "Sudima Auckland City is a contemporary 4.5-star hotel situated at 63-67 Nelson Street in the heart of Auckland's central business district. Opened in late 2020, it offers 186 rooms and suites, combining modern design with sustainable practices. The hotel is conveniently located within walking distance of Auckland’s shopping, arts, dining, and entertainment precincts, and directly opposite the New Zealand International Convention Centre.",
    client: "CLL",
    location: "Auckland, New Zealand",
    services: " ",
    outcome: {
      image: [
        "/Sudima Hotel/Outcome 1.png",
        "/Sudima Hotel/Outcome 2.png",
        "/Sudima Hotel/Outcome 3.png",
      ],
    },
  },
  {
    title: "61 Molesworth Street",
    image: "/61 Molesworth Street/Button PNG.png",
    link: "/home_project/61_molesworth_street",
    showcase: "/61 Molesworth Street/Problem Photo.png",
    introduction:
      "The 61 Molesworth Street project is a landmark commercial development in Wellington's parliamentary precinct, set to become the new headquarters for the Ministry of Foreign Affairs and Trade (MFAT). Replacing the former ICI House, which was demolished following the 2016 Kaikōura earthquake, the new 11-storey building is designed with a strong emphasis on seismic resilience and environmental sustainability. Key features include advanced structural systems incorporating fluid viscous dampers, a fully glazed façade with vertical pleats for wind mitigation, and a target of a 6 Green Star rating from the New Zealand Green Building Council. The building offers approximately 24,000 square metres of office space, with MFAT occupying around 12,000 square metres under a 25-year lease agreement. Additional amenities include a ground-floor lobby café, meeting suites, and premium end-of-trip facilities. The project is scheduled for completion in 2025.",
    client: "Arch Coatings & Mc Guinness",
    location: "Wellington, New Zealand",
    services: "",
    outcome: {
      image: [
        "/61 Molesworth Street/Outcome 1.png",
        "/61 Molesworth Street/Outcome 2.png",
        "/61 Molesworth Street/Outcome 3.png",
      ],
    },
  },
];

export const defaultData = {
  title: "-",
  showcase: "-",
  introduction: "-",

  image: "-",
  link: "-",
  client: "-",
  location: "-",
  services: "-",

  outcome: {
    image: ["-"],
  },
};
